import script from "./ChassisSectionStandardTractor.vue?vue&type=script&setup=true&lang=js"
export * from "./ChassisSectionStandardTractor.vue?vue&type=script&setup=true&lang=js"

import "./ChassisSectionStandardTractor.vue?vue&type=style&index=0&id=9cf5aedc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cf5aedc"]])

export default __exports__